import { Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Z_INDICES } from 'dashboard/styles/variables';
import { paragraphMixins } from 'design-system/mixins/text';
import { BASE } from 'design-system/variables/spacing';

export const BANNER_MIN_HEIGHT = BASE * 7;

const Container = styled('div')<Pick<BannerProps, 'backgroundColor' | 'sticky' | 'centered'>>`
  ${paragraphMixins.md};
  width: 100%;
  min-height: ${BANNER_MIN_HEIGHT}px;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor ?? theme.color.variants.caution.highlightLight};
  display: flex;
  align-items: center;
  padding: 0 ${Spacing[7]};
  justify-content: flex-start;

  ${({ centered }) =>
    centered &&
    css`
      justify-content: center;
    `}

  ${({ sticky }) =>
    sticky &&
    css`
      position: sticky;
      top: 0;
      z-index: ${Z_INDICES.banner};
    `}
`;

const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-right: ${Spacing[4]};
  color: ${({ theme }) => theme.color.text.primary};

  svg *[stroke] {
    stroke: ${({ theme }) => theme.color.text.primary};
  }
`;

interface BannerProps {
  children?: ReactNode;
  icon?: ReactNode;
  'data-test'?: string;
  className?: string;
  backgroundColor?: string;
  sticky?: boolean;
  centered?: boolean;
}

const Banner = ({
  children,
  icon,
  'data-test': dataTest,
  className,
  backgroundColor,
  sticky = true,
  centered = false,
}: BannerProps) => {
  return (
    <Container
      data-test={dataTest}
      className={className}
      backgroundColor={backgroundColor}
      sticky={sticky}
      centered={centered}
    >
      {icon != null && <IconContainer>{icon}</IconContainer>}
      <div>{children}</div>
    </Container>
  );
};

export default Banner;
